module.exports = __webpack_public_path__ + "public/Icons/surgeDelete.svg?97964360";